<template>
  <div>
    <div v-if="isApp === 'yes'" class="header-placeholder"></div>
    <div class="params-table">
      <div class="params-table-top " ref="tableTop">
        <div class="params-table-top-lf">
          <my-dropdown @on-click="(index) => tabChange(index)">
            <div class="params-table-title">
              <span>{{ typeName }}</span>
              <svg-icon class="icon" name="ChevronDown"></svg-icon>
            </div>
            <my-dropdown-menu class="params-table-top-menu" style="width:240px">
              <my-dropdown-item
                v-for="(item, index) in tab"
                :key="index"
                :name="index"
              >
                <div class="typebox-item">
                  <span>{{ item.label }}</span>
                  <svg-icon
                    v-if="
                      utils.removeSpacesAndConvertToUpper(item.label) ==
                        utils.removeSpacesAndConvertToUpper(type)
                    "
                    name="Checkmark"
                    class="typebox-item-icon"
                  ></svg-icon>
                </div>
              </my-dropdown-item>
            </my-dropdown-menu>
          </my-dropdown>

          <div class="params-table-desc">{{ textDict[language] }}</div>
        </div>
      </div>
      <div class="params-content">
        <div class="params-table-tab pc" :class="{ fixed: fixed }">
          <div ref="scrollNav" class="params-table-nav-main">
            <div
              class="params-table-nav-main-item h4"
              v-for="(item, index) in navPc"
              :class="{ active: index === activeIndex }"
              :key="index"
              @click="changeNav(index)"
            >
              {{ item.typeName }}
            </div>
          </div>
        </div>
        <div class="params-table-rt" :class="{ fixed: fixed }">
          <div ref="navHolder" class="params-table-nav-outer">
            <div ref="nav" class="params-table-nav">
              <img
                class="params-table-nav-img pc"
                :src="
                  version.photoList && version.photoList[0]
                    ? version.photoList[0].photo
                    : ''
                "
              />
              <img
                class="params-table-nav-img pad"
                :src="
                  version.photoList && version.photoList[0]
                    ? version.photoList[0].photo
                    : ''
                "
              />
              <div
                class="params-table-nav-imgbox mb"
                :class="{ 'one-screen-img': phoneOneScreenCar.includes(type) }"
                :style="{ left: imgPosition === 'left' ? 0 : '-100%' }"
              >
                <img
                  class="params-table-nav-img"
                  :src="
                    versionPhone.photoList && versionPhone.photoList[0]
                      ? versionPhone.photoList[0].photo
                      : ''
                  "
                />
                <div
                  class="iconbox"
                  :style="{ left: imgPosition === 'left' ? '-100vw' : '100vw' }"
                  v-if="!phoneOneScreenCar.includes(type)"
                >
                  <div class="icon icon-left" @click="imgPosition = 'left'">
                    <svg-icon name="ArrowLeft"></svg-icon>
                  </div>
                  <div class="icon icon-right" @click="imgPosition = 'right'">
                    <svg-icon name="ArrowRight"></svg-icon>
                  </div>
                </div>
              </div>
              <div class="params-table-nav-bottom">
                <div class="params-table-nav-bottom-box">
                  <div class="params-table-nav-bottom-lf">
                    <span>●</span>
                    <span>{{ settingDict[language].first }}</span>
                    <span>○</span>
                    <span>{{ settingDict[language].second }}</span>
                    <span>━</span>
                    <span>{{ settingDict[language].third }}</span>
                  </div>
                  <div
                    class="params-table-nav-bottom-rt"
                    @click="visible = !visible"
                  >
                    <span class="pad">{{
                      navPc.find((i, index) => index == activeIndex)
                        ? navPc.find((i, index) => index == activeIndex)
                            .typeName
                        : ""
                    }}</span>
                    <span class="mb mb-name">{{
                      navPhone.find((i, index) => index == activeIndex)
                        ? navPhone.find((i, index) => index == activeIndex)
                            .typeName
                        : ""
                    }}</span>
                    <svg-icon
                      class="icon"
                      :name="visible ? 'ChevronUp' : 'ChevronDown'"
                    ></svg-icon>
                  </div>
                </div>
                <Drawer
                  class="drawer"
                  type="top"
                  top="56px"
                  absolute
                  height="380px"
                  :zIndex="9999"
                  :mask="false"
                  :visible.sync="visible"
                  style="height:380px;"
                >
                  <!-- pad -->
                  <div class="tabbox pad">
                    <div
                      v-for="(item, index) in navPc"
                      :key="index"
                      class="tabboxitem"
                      :class="{
                        active: index == activeIndex,
                      }"
                      @click="
                        visible = false;
                        activeIndex = index;
                        changeNav(index);
                      "
                    >
                      {{ item.typeName }}
                    </div>
                  </div>
                  <!-- phone -->
                  <div class="tabbox mb">
                    <div
                      v-for="(item, index) in navPhone"
                      :key="index"
                      class="tabboxitem"
                      :class="{
                        active: index == activeIndex,
                      }"
                      @click="
                        visible = false;
                        activeIndex = index;
                        changeNav(index);
                      "
                    >
                      {{ item.typeName }}
                    </div>
                  </div>
                </Drawer>
              </div>
            </div>
          </div>
          <div class="params-table-images pc">
            <div
              class="params-table-imagebox"
              v-for="(item, idx) in navPc"
              :key="item.index"
            >
              <img
                :class="[
                  'image-' + (idx + 1),
                  index == 0 ? 'params-table-image' : '',
                ]"
                v-for="(c, index) in item.photoList"
                :key="index"
                :src="c.photo"
              />
            </div>
          </div>
          <div class="params-table-images pad">
            <div
              class="params-table-imagebox"
              v-for="(item, idx) in navPc"
              :key="item.index"
            >
              <img
                :class="[
                  'image-' + (idx + 1),
                  index == 0 ? 'params-table-image' : '',
                ]"
                v-for="(c, index) in item.photoList"
                :key="index"
                :src="c.photo"
              />
            </div>
          </div>
          <div class="params-table-images mb">
            <div
              class="params-table-imagebox"
              :class="{ 'one-screen-img': phoneOneScreenCar.includes(type) }"
              :style="{ 'margin-left': imgPosition === 'left' ? 0 : '-100%' }"
              v-for="(item, idx) in navPhone"
              :key="item.index"
            >
              <img
                :class="[
                  'image-' + (idx + 1),
                  index == 0 ? 'params-table-image' : '',
                ]"
                v-for="(c, index) in item.photoList"
                :key="index"
                :src="c.photo"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SvgIcon from "@components/Icon/index.vue";
import Drawer from "@components/Drawer/index.vue";
import MyDropdown from "@components/Dropdown/MyDropdown.vue";
import MyDropdownMenu from "@components/Dropdown/MyDropdownMenu.vue";
import MyDropdownItem from "@components/Dropdown/MyDropdownItem.vue";
import BackToTopButton from "@components/BackToTopButton/index.vue";
import utils from "@utils";
import { getConfig } from "@api/paramsTableConfig";
import { getDevice } from "@utils/device";
export default {
  components: {
    SvgIcon,
    Drawer,
    BackToTopButton,
    MyDropdown,
    MyDropdownMenu,
    MyDropdownItem,
  },
  props: {
    language: {
      type: String,
      default: "CHINESE",
    },
  },
  data() {
    this.evenFunc = null;
    this.tops = null;
    this.nowTop = null;
    this.navs = null;
    return {
      tab: [],
      type: "",
      isApp: "",
      typeName: "",
      activeIndex: 0,
      navPc: [],
      navPhone: [],
      version: {},
      versionPhone: {},

      fixed: false,
      visible: false,
      imgPosition: "left",

      phoneOneScreenCar: ["A06", "007", "A06PLUS"], // A06和007 phone端不需要左右移动
      device: "",
      utils,

      textDict: {
        CHINESE: "参数配置表",
        ENGLISH: "Specs",
      },
      settingDict: {
        CHINESE: {
          first: "标配",
          second: "选配",
          third: "无",
        },
        ENGLISH: {
          first: "Standard",
          second: "Optional",
          third: "N/A",
        },
      },
    };
  },
  created() {
    let type = utils.removeSpacesAndConvertToUpper(
      utils.getQueryString("type")
    );
    this.isApp = utils.getQueryString("isApp");
    this.type = type || "V09";
    this.getCatConfig(() => {
      if (this.isApp === "yes") {
        if (this.language === "CHINESE") {
          document.title = this.typeName ? this.typeName + "配置表" : "配置表";
        } else {
          document.title = this.typeName ? this.typeName + " Specs" : "Specs";
        }
      } else {
        if (this.language === "CHINESE") {
          document.title = "HYCAN 合创汽车 | 配置表";
        } else {
          document.title = "HYCAN | Specs";
        }
      }
    });
  },
  mounted() {
    this.device = getDevice();
    utils.onImgLoaded(() => {
      this.initEvent();
    });
  },
  unMounted() {
    this.removeEvent();
  },
  methods: {
    tabChange(index) {
      const item = this.tab[index];
      this.type = utils.removeSpacesAndConvertToUpper(item.label);
      this.imgPosition = "left";
      this.getCatConfig();
    },
    getCatConfig(cb) {
      getConfig({
        language: this.language,
      }).then((r) => {
        const dta = (r.data || []).map((i) => {
          i.seriesName = i.seriesName === "A06PLUS" ? "A06 PLUS" : i.seriesName;
          return i;
        });
        this.tab = dta.map((i) => ({
          label: i.seriesName,
        }));
        const list =
          dta.find(
            (d) =>
              utils.removeSpacesAndConvertToUpper(d.seriesName) ==
              utils.removeSpacesAndConvertToUpper(this.type)
          ) || {};
        console.log(list);
        this.typeName = list.seriesName;
        cb && cb();
        const typeList = (list.typeList || []).filter(
          (t) => t.terminal === "PC"
        );
        this.version = typeList[0] || {};
        this.navPc = typeList.filter((_, index) => index != 0);

        const typeListPhone = (list.typeList || []).filter(
          (t) => t.terminal === "PHONE"
        );
        this.versionPhone = typeListPhone[0] || {};
        console.log(this.versionPhone);
        this.navPhone = typeListPhone.filter((_, index) => index != 0);
        this.removeEvent();
        this.$nextTick(() => {
          utils.onImgLoaded(() => {
            this.initEvent();
          });
        });
      });
    },
    initScrollTops() {
      let { nav, tableTop } = this.$refs;
      const tableTopH = tableTop.clientHeight + 16; // 16是margin
      let headerEl = document.querySelector(`.header-placeholder`);
      this.navs = [...document.querySelectorAll(`.params-table-nav-main-item`)];
      // this.tops = [...document.querySelectorAll(`.params-table-image`)]
      //   .filter((v) => v.offsetTop)
      //   .map((v) => v.offsetTop - headerEl.clientHeight - nav.clientHeight);
      let tops = [];
      let top = 0; // 类似于求和累加
      tops.push(top);
      // 收集tops
      let lis = [...document.querySelectorAll(`.params-table-image`)].filter(
        (v) => v.offsetTop
      ); // 伪数组
      Array.prototype.slice.call(lis).forEach((li, index) => {
        if (index === 0) {
          top += li.clientHeight + headerEl.clientHeight + nav.clientHeight;
          if (this.device === "IPHONE") {
            top = top - tableTopH;
          }
        } else {
          top += li.clientHeight;
        }
        tops.push(top);
      });
      // console.log(tops);
      // 更新tops
      this.tops = tops;
    },
    checkNavActive(scrollTop) {
      let index = this.tops.findIndex((top, index) => {
        // scrollY要大于等于当前top值，还要小于下一个top
        return scrollTop >= top && scrollTop < this.tops[index + 1];
      });

      if (!this.lockCheck) {
        this.activeIndex = index;
      }

      this.$refs.scrollNav.scrollTop = 60 * this.activeIndex;
    },
    checkNavFixed(navHolder, nav, headerEl, scrollTop) {
      let navTop = navHolder.offsetTop - headerEl.clientHeight;
      if (scrollTop >= navTop) {
        navHolder.style.height = nav.clientHeight + "px";
        nav.classList.add("fixed");
        this.fixed = true;
        this.isApp === "yes" && nav.classList.add("top_0");
      } else {
        navHolder.style.height = "";
        this.fixed = false;
        nav.classList.remove("fixed");
        this.isApp === "yes" && nav.classList.remove("top_0");
      }
    },
    initEvent() {
      this.initScrollTops();
      let { navHolder, nav } = this.$refs;
      let headerEl = document.querySelector(`.header-placeholder`);
      let scrollEl = document.scrollingElement || document.documentElement;
      this.scrollFunc = (ev) => {
        let el = ev.target.scrollingElement;
        let scrollTop = el.scrollTop;
        this.checkNavFixed(navHolder, nav, headerEl, scrollTop);
        this.checkNavActive(scrollTop);
      };
      this.resetFunc = () => {
        this.device = getDevice();
        this.initScrollTops();
      };
      window.addEventListener("scroll", this.scrollFunc, false);
      window.addEventListener("resize", this.resetFunc, false);
      this.checkNavFixed(navHolder, nav, headerEl, scrollEl.scrollTop);
      this.checkNavActive(scrollEl.scrollTop);
      // this.navScroll(this.activeIndex, true);
    },
    removeEvent() {
      window.removeEventListener("scroll", this.evenFunc);
      window.removeEventListener("resize", this.resetFunc);
    },
    changeNav(index) {
      this.activeIndex = index;
      let { nav } = this.$refs;
      let els = document.querySelectorAll(`.image-${index + 1}`);
      let el = [...els].filter((v) => v.offsetTop)[0];
      let headerEl = document.querySelector(`.header-placeholder`);
      let offsetTop = el.offsetTop;
      if (el.offsetTop > nav.offsetTop) {
        offsetTop -= nav.clientHeight;
      }
      this.animateScroll(offsetTop - headerEl.clientHeight);
    },
    navScroll(index, noAni) {
      let item = this.navs[index];
      let el = this.$refs.scrollNav;
      let nowLeft = el.scrollLeft;
      let left = item.offsetLeft;
      if (noAni) {
        return el.scrollTo(left, 0);
      }
      let moveL = left - nowLeft;
      let duration = 260;
      if (moveL === 0) return;
      let startTime = +new Date();
      let run = () => {
        let time = +new Date() - startTime;
        let nextLeft = nowLeft + moveL * (time / duration);
        el.scrollTo(nextLeft, 0);
        run.timer = requestAnimationFrame(run);
        if (time >= duration) {
          el.scrollTo(left, 0);
          cancelAnimationFrame(run.timer);
        }
      };
      run();
    },
    animateScroll(top) {
      let scroller = document.scrollingElement || document.documentElement;
      let pageY = scroller.scrollTop;
      let mY = top - pageY;
      let startTime = +new Date();
      let duration = 450; //ms
      let run = () => {
        let time = +new Date() - startTime;
        let nextTop = pageY + mY * (time / duration);
        scroller.scrollTo(0, nextTop);
        run.timer = requestAnimationFrame(run);
        if (time >= duration) {
          scroller.scrollTo(0, top);
          cancelAnimationFrame(run.timer);
          setTimeout(() => {
            this.lockCheck = false;
          }, 100);
        }
      };
      this.lockCheck = true;
      requestAnimationFrame(run);
    },
  },
};
</script>
<style lang="scss">
@import "@style/base";
@import "@style/common";
.params-table {
  // overflow: hidden;
  margin: 0 auto;
  width: 1432px;
  @include media(
    (
      $bg: (
        width: 1136px,
      ),
      $md: (
        width: 100%,
      ),
    )
  );
  ::-webkit-scrollbar {
    display: none; /* Chrome Safari */
  }
  .params-table-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 32px 0;
    margin-bottom: 32px;
    border-bottom: 1px solid #eee;
    .params-table-top-lf {
      display: flex;
      align-items: center;
    }
    @include media(
      (
        $md: (
          padding: 16px,
          margin-bottom: 16px,
        ),
      )
    );
    .params-table-title {
      cursor: pointer;
      font-family: Saira-Regular;
      font-size: 36px;
      line-height: 58px;
      @include media(
        (
          $bg: (
            font-size: 34px,
            line-height: 54px,
          ),
          $md: (
            font-size: 24px,
            line-height: 38px,
          ),
        )
      );
      .icon {
        font-size: 24px;
        margin-left: 16px;
        @include media(
          (
            $md: (
              margin-left: 8px,
            ),
          )
        );
      }
      &::after {
        content: "";
        display: inline-block;
        width: 1px;
        height: 1em;
        background: #eee;
        margin: 0 16px;
        position: relative;
        top: 4px;
        @include media(
          (
            $md: (
              margin: 0 8px,
            ),
          )
        );
      }
    }
    .params-table-top-menu {
      z-index: 10;
      left: 2px;
      @include media(
        (
          $md: (
            left: 0,
          ),
        )
      );
    }
    .typebox-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 22px;
      line-height: 36px;
      @include media(
        (
          $bg: (
            font-size: 18px,
            line-height: 28px,
          ),
          $md: (
            font-size: 16px,
            line-height: 26px,
          ),
        )
      );
      .typebox-item-icon {
        font-size: 24px;
      }
    }
    .params-table-desc {
      font-size: 22px;
      line-height: 36px;
      @include media(
        (
          $bg: (
            font-size: 18px,
            line-height: 28px,
          ),
          $md: (
            font-size: 16px,
            line-height: 26px,
          ),
        )
      );
    }
  }

  .params-content {
    display: flex;
  }
  .params-table-tab {
    position: relative;
    flex: 0 0 244px;
    @include media(
      (
        $bg: (
          flex: 0 0 192px,
        ),
      )
    );
    &.fixed {
      width: 244px;
      position: fixed;
      top: 48px;
      padding-top: 32px;
      @include media(
        (
          $bg: (
            flex: 0 0 192px,
          ),
        )
      );
    }
    .params-table-nav-main {
      width: 244px;
      position: relative;
      max-height: 70vh;
      overflow: hidden;
      // overflow-y: auto;
      @include media(
        (
          $bg: (
            width: 192px,
          ),
        )
      );

      .params-table-nav-main-item {
        // height: 60px;
        display: flex;
        align-items: center;
        // padding: 0 16px;
        padding: 16px 24px 16px 16px;
        color: #878889;
        font-size: 18px;
        line-height: 28px;
        cursor: pointer;
        transition: font-size 260ms $easeOutCubic;
        position: relative;
        &::before {
          content: "";
          display: inline-block;
          width: 3px;
          height: 100%;
          position: absolute;
          left: 0;
          background-color: #eee;
          @include media(
            (
              $md: (
                display: none,
              ),
            )
          );
        }
        &:first-child {
          &::before {
            height: calc(100% - 15px);
            top: 15px;
          }
        }
        &:last-child {
          &::before {
            height: calc(100% - 10px);
            top: -10px;
          }
        }
        &.active {
          color: #131415;
          &::after {
            content: "";
            display: inline-block;
            width: 3px;
            height: 28px;
            position: absolute;
            left: 0;
            background-color: #131415;
            @include media(
              (
                $md: (
                  display: none,
                ),
              )
            );
          }
        }
      }
    }
  }
  .params-table-rt {
    flex: 1;
    &.fixed {
      flex: 0 0 1188px;
      margin-left: 244px;
      @include media(
        (
          $bg: (
            margin-left: 192px,
            flex: 0 0 944px,
          ),
          $md: (
            flex: 1,
            margin-left: 0,
          ),
        )
      );
    }
  }
  .params-table-logo {
    margin: 80px auto 24px;
    width: 306px;
    height: 56px;
    display: block;
  }
  .params-table-desc {
    text-align: center;
  }
  .params-table-nav-outer {
    .params-table-nav {
      &.fixed {
        position: fixed;
        top: 48px;
        width: 1188px;
        left: calc(50% + 122px);
        transform: translateX(-50%);
        padding-top: 32px;
        background-color: #fff;
        &.top_0 {
          top: 0;
        }
        @include media(
          (
            $bg: (
              width: 944px,
              left: calc(50% + 96px),
            ),
            $md: (
              width: auto,
              transform: translateX(0),
              padding-top: 0,
              left: 0,
              right: 0,
            ),
          )
        );
      }
      @include setThemeClass {
      }
      .params-table-nav-imgbox {
        width: 100%;
        position: relative;
        background-color: #fff;
        @include media(
          (
            $sm: (
              width: 200%,
            ),
          )
        );
        &.one-screen-img {
          @include media(
            (
              $sm: (
                width: 100%,
              ),
            )
          );
        }
        .iconbox {
          width: 100%;
          position: absolute;
          top: 0;
          bottom: 0;
          left: -100vw;
          right: 0;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0 8px;
          .icon {
            width: 48px;
            height: 48px;
            display: flex;
            justify-content: center;
            align-items: center;
            background: rgba(238, 238, 238, 0.6);
            border-radius: 50%;
            font-size: 24px;
          }
        }
      }
      .params-table-nav-bottom {
        display: none;
        z-index: 2;
        background-color: #fff;
        font-size: 14px;
        line-height: 22px;
        position: relative;
        overflow: visible;
        @include media(
          (
            $md: (
              display: block,
            ),
          )
        );
        .params-table-nav-bottom-box {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 16px;
        }
        .params-table-nav-bottom-lf {
          opacity: 0;
          display: flex;
          > span {
            display: inline-block;
            margin-right: 16px;

            &:nth-child(odd) {
              margin-right: 8px;
            }
          }
          @include media(
            (
              $sm: (
                opacity: 1,
              ),
            )
          );
        }
        .params-table-nav-bottom-rt {
          display: none;
          // font-size: 18px;
          // line-height: 28px;
          @include media(
            (
              $md: (
                display: flex,
                align-items: center,
              ),
            )
          );
          .mb-name {
            display: none;
            @include maxLine(1);
            @include media(
              (
                $md: (
                  display: -webkit-box,
                ),
              )
            );
          }
          .icon {
            font-size: 16px;
            margin-left: 4px;
          }
        }
      }
      .params-table-nav-img {
        width: 100%;
        height: auto;
      }
    }
  }
  .params-table-images {
    .params-table-imagebox {
      width: 100%;
      height: auto;
      @include media(
        (
          $sm: (
            width: 200%,
          ),
        )
      );
      &.one-screen-img {
        @include media(
          (
            $sm: (
              width: 100%,
            ),
          )
        );
      }
    }
    img {
      width: 100%;
      height: 100%;
      display: block;
    }
  }
}
.drawer {
  .tabbox {
    width: 100vw;
    overflow-y: auto;
    padding: 24px 16px;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 16px;

    @include media(
      (
        $sm: (
          grid-template-columns: repeat(2, 1fr),
        ),
      )
    );
    .tabboxitem {
      width: 100%;
      height: 58px;
      line-height: 58px;
      text-align: center;
      background-color: #f3f3f3;
      font-size: 16px;
      padding: 0 8px;
      @include maxLine(1);
    }
    .active {
      background-color: #131415;
      color: #fff;
    }
  }
  .pad {
    display: none;
    @include media(
      (
        $md: (
          display: grid,
        ),
        $sm: (
          display: none,
        ),
      )
    );
  }
  .mb {
    display: none;
    @include media(
      (
        $sm: (
          display: grid,
        ),
      )
    );
  }
}
</style>
